import { OverridesStyleRules } from '@mui/material/styles/overrides';

import { tablePaginationInterpolation } from '../interpolations/table-pagination.interpolation';
import {
  tableBlack,
  tableBorderColor,
  tableWhite,
} from '../variables/variables';

export const tablePaginationOverrides:
  | Partial<
      OverridesStyleRules<
        | 'root'
        | 'toolbar'
        | 'spacer'
        | 'select'
        | 'selectLabel'
        | 'selectIcon'
        | 'input'
        | 'displayedRows',
        'MuiTableCell'
      >
    >
  | undefined = {
  root: tablePaginationInterpolation,
  toolbar: {
    display: 'flex',
    gap: '10px',
  },
  spacer: {
    display: 'none',
  },
  selectLabel: {
    order: 1,
  },
  select: {
    backgroundColor: tableWhite,
    border: `1px solid ${tableBorderColor}`,
    borderRadius: '5px',

    '&:focus': {
      backgroundColor: tableWhite,
      border: `1px solid ${tableBorderColor}`,
      borderRadius: '5px',
    },
  },
  input: {
    order: 2,
  },
  displayedRows: {
    order: 5,
  },
  selectIcon: {
    fill: tableBlack,
  },
};
